import _extends from '/app/node_modules/babel-runtime/helpers/extends';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import MenuOptions from '~/components/menu-options';
import { CloseSessionModal } from '~/components/modals';

export default {
    head: function head() {
        return {
            title: this.$store.state.dashboard.details.toolbarTitle
        };
    },

    components: {
        MenuOptions: MenuOptions,
        CloseSessionModal: CloseSessionModal
    },
    data: function data() {
        return {
            drawer: false,
            title: this.$store.state.dashboard.details.toolbarTitle
        };
    },

    computed: _extends({}, mapState({
        user: function user(state) {
            return state.user;
        },
        toolbarTitle: function toolbarTitle(state) {
            return state.dashboard.details.toolbarTitle;
        },
        toolbarBackUrl: function toolbarBackUrl(state) {
            return state.dashboard.details.toolbarBackUrl;
        },
        showToolbarBackButton: function showToolbarBackButton(state) {
            return state.dashboard.details.showToolbarBackButton;
        },
        dashboard: function dashboard(state) {
            return state.dashboard;
        },
        firstName: function firstName(state) {
            return state.user.firstName;
        },
        lastName: function lastName(state) {
            return state.user.lastName;
        },
        isSuperUser: function isSuperUser(state) {
            return state.user.isSuperUser;
        },
        isPublicPage: function isPublicPage(state) {
            return state.isPublicPage;
        }
    }), {
        mobile: function mobile() {
            return this.$vuetify.breakpoint.smAndDown || false;
        },
        desktop: function desktop() {
            return this.$vuetify.breakpoint.smAndUp;
        }
    }),
    methods: {
        dashboardRouter: function dashboardRouter() {
            this.$router.push('/dashboard');
        },
        newAffiliationRouter: function newAffiliationRouter() {
            this.$router.push('/new-affiliation');
        },
        collaboratorsRouter: function collaboratorsRouter() {
            //this.$isAdmin() || this.$isBoss() || this.$isSupervisor() ? this.$router.push('/collaborators') : ''
            if (this.$isSupervisor() == true) {
                this.$router.push('/my-team');
            } else if (this.$isBoss() == true) {
                this.$router.push('/channels');
            } else if (this.$isAdmin() || this.$isAdminCollaborator()) {
                this.$router.push('/bosses');
            }
        },
        reportsRouter: function reportsRouter() {
            this.$router.push('/reports');
        },
        tariffRouter: function tariffRouter() {
            this.$router.push('/tariff');
        },
        profileRouter: function profileRouter() {
            this.$router.push('/profile');
        },
        commissionPreviewerRouter: function commissionPreviewerRouter() {
            this.$router.push('/commisionPreviewer');
        }
    },
    mounted: function mounted() {
        window.loading_screen.finish();
    },

    watch: {
        toolbarTitle: function toolbarTitle(val) {
            console.log("val -->", val);
            this.title = val;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layouts/default.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layouts/default.vue
// module chunks = 20